import React, { useEffect, useState } from 'react';
import "../../assets/styles/Search.css";
import "../../assets/styles/Profile.css";
import Popup from "reactjs-popup";
import { motion } from "framer-motion";
import Header from "../../components/Header.js";
import DataConfirm from "../../components/Profile/DataConfirm.js";
import HtmlNote from "../../components/Profile/HtmlNote.js";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../../components/helper/Loading.js";
import { config } from "../../config.js";
import {
  apiCheckDataAccount,
  apiFormUpdateAccount,
  apiGetRequestHistory,
} from "../../services/api.service.js";
import { maskRequestCode } from "../../utils/requestHistory.js";
import { normalizePersonName } from "../../utils/normalizePersonName.js";
import {
  Box,
  Button,
  Typography,
  IconButton,
} from "@mui/material";
import { AddPhotoAlternateOutlined, Close } from "@mui/icons-material";
import badgeEmail from "../../imgs/figma_icons/badge-email.png";
import badgePhone from "../../imgs/figma_icons/badge-phone.png";
import iconUploadImage from "../../imgs/figma_icons/icon-upload-image.png";
import modalSuccess from "../../imgs/figma_icons/modal-success.png";
import modalClose from "../../imgs/figma_icons/modal-close.png";
import modalExclamation from "../../imgs/figma_icons/modal-exclamation.png";
import iconInfoCircle from "../../imgs/figma_icons/icon-info-circle.png";

function RequestProcessingStatus({
  submittedRequest,
  pollingChecks,
  isRefreshingRequest,
  requestRefreshMessage,
  refreshSubmittedRequest,
  copySubmittedRequestCode,
}) {
  if (!submittedRequest) return null;
  const needsVerification = ["email", "phone_number"].includes(submittedRequest.send_type);

  return (
    <div className={`request-processing-status status-${submittedRequest.status} verification-${needsVerification ? submittedRequest.verification_status || "not_received" : "success"}`}>
      {submittedRequest.status === "no_process" && (
        <div className={`request-live-update-notice ${pollingChecks >= 15 ? "request-live-update-stopped" : ""}`} role="status" aria-live="polite">
          {pollingChecks < 15 ? <span className="request-loading-icon" aria-hidden="true" /> : <span className="request-update-paused-icon" aria-hidden="true">✓</span>}
          <div>
            <strong>{pollingChecks < 15 ? "Hệ thống đang tự động cập nhật trạng thái" : ""}</strong>
            <small>{pollingChecks < 15 ? "Vui lòng giữ màn hình này mở và chờ kết quả xử lý." : "Bạn có thể bấm Kiểm tra lại để lấy trạng thái mới nhất."}</small>
          </div>
        </div>
      )}
      <strong className="request-processing-title">
        {submittedRequest.status === "approved"
          ? "Yêu cầu đã được xử lý thành công"
          : submittedRequest.status === "removed"
            ? "Yêu cầu đã bị từ chối"
            : needsVerification && submittedRequest.verification_status === "invalid"
              ? "Đã nhận tin xác thực nhưng thông tin gửi không khớp"
              : needsVerification && submittedRequest.verification_status !== "success"
                ? "Yêu cầu đang chờ xác thực"
                : pollingChecks < 15 ? "Yêu cầu đang được xử lý" : "Yêu cầu đang được xử lý lâu hơn dự kiến"}
      </strong>
      <p className="submitted-request-code">Mã yêu cầu: <strong>{submittedRequest.request_code}</strong></p>
      {(submittedRequest.note || submittedRequest.result) && (
        <div className="request-result-note">
          <strong>Kết quả xử lý:</strong>
          <HtmlNote html={submittedRequest.note || submittedRequest.result} />
        </div>
      )}
      <div className="request-progress">
        <div className="request-progress-step step-complete"><span>1</span><small>Đã gửi yêu cầu</small></div>
        <div className={`request-progress-step ${!needsVerification || submittedRequest.verification_status === "success" ? "step-complete" : submittedRequest.verification_status === "invalid" ? "step-error" : "step-current"}`}>
          <span>2</span><small>{needsVerification ? "Xác thực" : "Đã tiếp nhận"}</small>
        </div>
        <div className={`request-progress-step ${submittedRequest.status === "approved" ? "step-complete" : submittedRequest.status === "removed" ? "step-error" : needsVerification && submittedRequest.verification_status !== "success" ? "step-pending" : "step-current"}`}>
          <span>3</span><small>Đang xử lý</small>
        </div>
        <div className={`request-progress-step ${submittedRequest.status === "approved" ? "step-complete" : submittedRequest.status === "removed" ? "step-error" : "step-pending"}`}>
          <span>4</span><small>Hoàn tất</small>
        </div>
      </div>
      {submittedRequest.status === "no_process" && (
        <div className="request-processing-message">
          {submittedRequest.verification_status === "not_received" && submittedRequest.send_type === "email" && <p>Chưa nhận xác thực. Vui lòng gửi từ email đã liên kết.</p>}
          {submittedRequest.verification_status === "not_received" && submittedRequest.send_type === "phone_number" && <p>Chưa nhận xác thực. Vui lòng gửi từ số điện thoại đã liên kết.</p>}
          {submittedRequest.verification_status === "invalid" && submittedRequest.send_type === "email" && <p>Đã nhận được email xác thực nhưng địa chỉ email gửi đến không khớp. Vui lòng gửi lại từ đúng email đã liên kết.</p>}
          {submittedRequest.verification_status === "invalid" && submittedRequest.send_type === "phone_number" && <p>Đã nhận được SMS xác thực nhưng số điện thoại gửi đến không khớp. Vui lòng gửi lại từ đúng SĐT đã liên kết.</p>}
          {submittedRequest.verification_status === "invalid" && !["email", "phone_number"].includes(submittedRequest.send_type) && <p>Xác thực không hợp lệ. Vui lòng kiểm tra thông tin và gửi lại.</p>}
          {pollingChecks >= 15 && (
            <>
              <p>Yêu cầu đang xử lý lâu hơn dự kiến.</p>
              <div className="request-processing-actions">
                <button type="button" onClick={refreshSubmittedRequest} disabled={isRefreshingRequest}>{isRefreshingRequest ? "Đang kiểm tra..." : "Kiểm tra lại"}</button>
                <button type="button" onClick={copySubmittedRequestCode}>Sao chép mã</button>
              </div>
            </>
          )}
          {requestRefreshMessage && <p className="request-refresh-message" role="status">{requestRefreshMessage}</p>}
        </div>
      )}
    </div>
  );
}

function ChangeInfo() {
  const location = useLocation();
  const { userName, data, webSetting, typeModal } = location.state || {};
  const [openResult, setOpenResult] = useState(false);
  const [checkConfirm, setCheckConfirm] = useState(false);
  const [isSendMail, setIsSendMail] = useState(true);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openUploadFile, setOpenUploadFile] = useState(false);
  const [previews, setPreviews] = useState([]);
  const [selectedImage, setSelectedImage] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [infoFileUpload, setInfoFileUpload] = useState("");
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const originalDataUpdate = {
    name: "",
    province: "",
    bank_type_change: "",
    bank_name: "",
    bank_number: "",
    email: "",
    phone_number: "",
  };
  const originalDesChangeBank = {
    title_change_bank: "THAY ĐỔI THÔNG TIN NGÂN HÀNG",
    bank_name: "Tên Ngân Hàng Mới",
    bank_number: "Số Tài Khoản Mới",
  };
  const desBankNew = {
    title_change_bank: "THÊM THÔNG TIN NGÂN HÀNG",
    bank_name: "Tên Ngân Hàng Mới",
    bank_number: "Số Tài Khoản Ngân Hàng Mới",
  };
  const desBankRemove = {
    title_change_bank: "XÓA SỐ TÀI KHOẢN NGÂN HÀNG",
    bank_name: "Tên Ngân Hàng Cần Xóa",
    bank_number: "Số Tài Khoản Cần Xóa",
  };
  const desUSDTNew = {
    title_change_bank: "THÊM VÍ USDT",
    blockchain: "TRC20",
    bank_number: "Ví USDT Mới",
  };
  const [desChangeBank, setDesChangeBank] = useState(originalDesChangeBank);
  const [dataUpdate, setDataUpdate] = useState(originalDataUpdate);
  const [timesCheckData, setTimesCheckData] = useState(0);
  const [dataCheck, setDataCheck] = useState({
    name: "",
    province: "",
    bank_name: "",
    bank_number: "",
    email: "",
    phone_number: "",
  });


  const [user, setUser] = useState({
    account: userName,
    update_type: "",
    status: "",
    auto_check: "",
    send_type: "",
  });
  const [submittedRequest, setSubmittedRequest] = useState(null);
  const [pollingChecks, setPollingChecks] = useState(0);
  const [isRefreshingRequest, setIsRefreshingRequest] = useState(false);
  const [requestRefreshMessage, setRequestRefreshMessage] = useState("");

  const inputDataCheck = (event) => {
    let { name, value } = event.target;
    if (name === "email") {
      value = value.toLowerCase().trim();
    }
    if (name === "phone_number") {
      value = value.trim();
    }
    setDataCheck({
      ...dataCheck,
      [name]: value,
    });
  };

  const inputDataUpdate = (event) => {
    const { name } = event.target;
    let { value } = event.target;
    if (name === "email") {
      value = value.toLowerCase();
    }
    if (name === "name") {
      // Viết hoa, bỏ dấu; chưa trim để còn gõ khoảng trắng giữa các từ
      value = normalizePersonName(value, { trimEnds: false });
    }
    setDataUpdate({
      ...dataUpdate,
      [name]: value,
    });
    if (name === "bank_type_change") {
      switch (value) {
        case "Thêm số tài khoản": setDesChangeBank(desBankNew)
          break;
        case "Xóa số tài khoản": setDesChangeBank(desBankRemove)
          break;
        case "Đổi số tài khoản": setDesChangeBank(originalDesChangeBank)
          break;
        case "Thêm Ví USDT": setDesChangeBank(desUSDTNew)
          setDataUpdate({
            ...dataUpdate,
            [name]: value,
            bank_name: "TRC20",
          });
          break;
        default: setDesChangeBank(originalDesChangeBank)
      }
    }
  };
  let contentUpdate;

  useEffect(() => {
    updateUserField("update_type", typeModal)
  }, []);

  useEffect(() => {
    if (!openConfirm || !submittedRequest?.request_code || submittedRequest.status !== "no_process" || pollingChecks >= 15) {
      return undefined;
    }

    const intervalId = setInterval(async () => {
      const result = await apiGetRequestHistory(userName, submittedRequest.request_code);
      setPollingChecks((count) => count + 1);
      if (result?.code === 200 && result?.data?.request) {
        setSubmittedRequest(result.data.request);
      }
    }, 30 * 1000);

    return () => clearInterval(intervalId);
  }, [openConfirm, submittedRequest?.request_code, submittedRequest?.status, pollingChecks, userName]);

  useEffect(() => {
    const shouldLockScroll = openConfirm || openUploadFile || openResult;
    if (!shouldLockScroll) return undefined;

    const previousOverflow = document.body.style.overflow;
    const previousTouchAction = document.body.style.touchAction;
    document.body.style.overflow = "hidden";
    document.body.style.touchAction = "none";

    return () => {
      document.body.style.overflow = previousOverflow;
      document.body.style.touchAction = previousTouchAction;
    };
  }, [openConfirm, openUploadFile, openResult]);

  /**
   * @param {string} [verifyType] - mail|email|phone_number|files — email chỉ bắt buộc khi xác thực qua email
   */
  const validateForm = (verifyType) => {
    let errors = {};
    let formIsValid = true;

    // Kiểm tra trường Name
    if (!dataCheck.name) {
      formIsValid = false;
      errors.name = 'Vui lòng nhập Họ và Tên';
    }

    // Kiểm tra trường phone_number
    if (data?.phone_number) {
      const phoneNumber = String(dataCheck.phone_number || "").trim();
      if (!phoneNumber) {
        formIsValid = false;
        errors.phone_number = 'Vui lòng nhập Số Điện Thoại';
      } else if (!/^\d{10}$/.test(phoneNumber)) {
        formIsValid = false;
        errors.phone_number = 'Số Điện Thoại không hợp lệ';
      }
    }

    // Email: bắt buộc chỉ khi xác thực qua email; để trống thì không tính vào % thông tin cũ (BE)
    if (data?.email) {
      const email = String(dataCheck.email || "").trim().toLowerCase();
      const requireEmail = verifyType === "mail" || verifyType === "email";
      if (requireEmail && !email) {
        formIsValid = false;
        errors.email = 'Vui lòng nhập Email để xác thực qua email';
      } else if (email && !/\S+@\S+\.\S+/.test(email)) {
        formIsValid = false;
        errors.email = 'Email không hợp lệ';
      }
    }

    // Kiểm tra trường bank_name
    if (!dataCheck.bank_name) {
      formIsValid = false;
      errors.bank_name = 'Vui lòng chọn Ngân Hàng';
    }

    // Kiểm tra trường bank_number
    if (!dataCheck.bank_number) {
      formIsValid = false;
      errors.bank_number = 'Vui lòng nhập Số Tài Khoản';
    }

    switch (typeModal) {
      case "full_name": // Kiểm tra trường Name update
        {
          const nameNormalized = normalizePersonName(dataUpdate.name);
          if (!nameNormalized) {
            formIsValid = false;
            errors.nameUpdate = 'Vui lòng nhập Họ và Tên mới';
          } else {
            contentUpdate = nameNormalized;
          }
        }
        break;
      case "phone_number":// Kiểm tra trường phone_number
        if (!dataUpdate.phone_number) {
          formIsValid = false;
          errors.phoneNumberUpdate = 'Vui lòng nhập Số Điện Thoại mới';
        } else if (!/^\d{10}$/.test(dataUpdate.phone_number)) {
          formIsValid = false;
          errors.phoneNumberUpdate = 'Số Điện Thoại mới không hợp lệ';
        } else {
          contentUpdate = dataUpdate.phone_number;
        }
        break;
      case "email":// Kiểm tra trường email
        if (!dataUpdate.email) {
          formIsValid = false;
          errors.emailUpdate = 'Vui lòng nhập Email mới';
        } else if (!/\S+@\S+\.\S+/.test(dataUpdate.email)) {
          formIsValid = false;
          errors.emailUpdate = 'Email mới không hợp lệ';
        } else {
          contentUpdate = dataUpdate.email;
        }
        break;
      case "bank":// Kiểm tra value bank
        if (!dataUpdate.bank_type_change) {
          formIsValid = false;
          errors.bankTypeChange = 'Vui lòng chọn yêu cầu thay đổi';
        }
        if (!dataUpdate.bank_name) {
          formIsValid = false;
          errors.bankNameUpdate = 'Vui lòng chọn Ngân Hàng mới';
        }
        if (!dataUpdate.bank_number) {
          formIsValid = false;
          errors.bankNumberUpdate = 'Vui lòng nhập Số Tài Khoản mới';
        } else {
          contentUpdate = (dataUpdate.bank_type_change + " - " + dataUpdate.bank_number + " - " + dataUpdate.bank_name);
        }
        break;
      case "birthday": // Kiểm tra trường birth day
        if (!dataUpdate.birth_day) {
          formIsValid = false;
          errors.birthDayUpdate = 'Vui lòng chọn ngày tháng năm sinh';
        } else {
          contentUpdate = dataUpdate.birth_day;
        }
        break;
      case "forget_password":
        contentUpdate = "Lấy mật khẩu đăng nhập";
        break;
      case "forget_password_withdraw":
        contentUpdate = "Lấy mật khẩu rút tiền";
        break;
      default: break
    }
    console.log(errors)
    setErrors(errors);
    return formIsValid;
  };
  const modalConfirmUpdate = (type) => {
    if (validateForm(type)) {
      if (type === 'mail' && !data?.email) {
        return Swal.fire({
          icon: "warning",
          title: "Chưa liên kết Email",
          text: "Tài khoản của bạn chưa liên kết Email. Vui lòng chọn gửi xác thực qua Số điện thoại hoặc tải ảnh/video xác thực.",
          confirmButtonText: "Đã hiểu",
        });
      }
      if (type === 'phone_number' && !data?.phone_number) {
        return Swal.fire({
          icon: "warning",
          title: "Chưa liên kết Số điện thoại",
          text: "Tài khoản của bạn chưa liên kết Số điện thoại. Vui lòng chọn gửi xác thực qua Email hoặc tải ảnh/video xác thực.",
          confirmButtonText: "Đã hiểu",
        });
      }
      if (type === 'files') {
        user.send_type = 'files';
        updateUserField('send_type', 'files')
        updateUser('files')
      } else {
        Swal.fire({
          icon: "warning",
          title: (type === "mail") ? `Bạn có thể sử dụng email ${data?.email || "liên kết"} để gửi mail xác thực thông tin?` : `Bạn có thể sử dụng số điện thoại ${data?.phone_number || "liên kết"} để gửi tin nhắn xác thực thông tin?`,
          text: (type === "mail") ? `Gửi SMS` : `Gửi email`,
          html: `
            <div className="confirm-update-wrapper">
              <button id="close_send_type" class="button-confirm-update button-confirm-secondary">Đóng</button>
              <button id="confirm_send_type" class="button-confirm-update button-confirm-primary">Đúng, tiếp tục</button>
            </div>
          `,
          showCancelButton: false,
          showConfirmButton: false,
          didRender: () => {
            document.getElementById('close_send_type')?.addEventListener('click', () => {
              Swal.close();
            });
            document.getElementById('confirm_send_type')?.addEventListener('click', () => {
              Swal.close();
              updateUser(type)
            });
          }
        })
      }
    }
  }

  const updateUserField = (field, value) => {
    setUser((prevUser) => ({
      ...prevUser,
      [field]: value,
    }));
  };

  const openModalConfirm = (type) => {
    setOpenConfirm(true);
  };

  const refreshSubmittedRequest = async () => {
    if (isRefreshingRequest || !submittedRequest?.request_code) return;
    setIsRefreshingRequest(true);
    setRequestRefreshMessage("");
    const result = await apiGetRequestHistory(userName, submittedRequest.request_code);
    if (result?.code === 200 && result?.data?.request) {
      setSubmittedRequest(result.data.request);
      setRequestRefreshMessage(`Đã cập nhật trạng thái mới nhất lúc ${new Date().toLocaleTimeString("vi-VN")}`);
    } else {
      setRequestRefreshMessage("Không thể cập nhật trạng thái. Vui lòng thử lại.");
    }
    setIsRefreshingRequest(false);
  };

  const copySubmittedRequestCode = async () => {
    try {
      await navigator.clipboard.writeText(submittedRequest?.request_code || "");
      setRequestRefreshMessage(`Đã sao chép: ${submittedRequest?.request_code}`);
    } catch (error) {
      setRequestRefreshMessage("Không thể sao chép mã yêu cầu.");
    }
  };

  const confirmUpdateUser = async (body, type) => {
    setLoading(true)
    let updateInfo = await apiFormUpdateAccount(body, selectedFiles);
    setLoading(false)
    const newRequestCode = updateInfo?.request_code;
    if (newRequestCode) {
      const newRequest = {
        ...body,
        request_code: newRequestCode,
        _request_code: newRequestCode,
        status: "no_process",
        verification_status: "not_received",
        createdAt: new Date().toISOString(),
      };
      user.request_code = newRequestCode;
      setUser((currentUser) => ({ ...currentUser, request_code: newRequestCode }));
      setSubmittedRequest(newRequest);
      setPollingChecks(0);
      setRequestRefreshMessage("");
      openModalConfirm(type);
    } else if (updateInfo) {
      openModalConfirm(type);
    }
  };
  const updateUser = async (type, submit) => {
    if (validateForm(type)) {
      if (type === "mail") {
        user.send_type = 'email';
        setIsSendMail(true);
      } else if (type === "phone_number") {
        user.send_type = 'phone_number';
        setIsSendMail(false);
      } else if (type === "files") {
        user.send_type = 'files';
        updateUserField('send_type', 'files')
        setIsSendMail(false);
      }
      let body = {
        ...user,
        data_check: {
          ...dataCheck,
        },
        data_update: {
          update_type: user.update_type,
          content: contentUpdate,
        }
      };
      setLoading(true)
      let checkDataOld = await apiCheckDataAccount(body);
      setLoading(false)
      if (checkDataOld) {
        if (type === "files" && !submit) {
          let descriptionFileUpload = "Bạn vui lòng tải lên ít nhất 3 trong " + webSetting?.des_up_files?.length + " hình ảnh/video dưới để xác minh tài khoản<br/><br/>";
          if (webSetting?.des_up_files?.length > 0) {
            webSetting.des_up_files.forEach(element => {
              descriptionFileUpload += (element) ? "" + element + "</br>" : ""
            });
          }
          descriptionFileUpload = "<p>" + descriptionFileUpload + "</p>";
          setInfoFileUpload(descriptionFileUpload)
          setOpenUploadFile(true);
          return;
        }
        let confirmUpdate = checkDataOld.result;
        let value_auto_check = confirmUpdate ? "check_success" : "check_fail";
        updateUserField("auto_check", value_auto_check);
        body.auto_check = value_auto_check;
        //nếu thông tin đúng hết hoặc đã nhập lại từ 5 lần và có số điện thoại hoặc email đúng thì tự động confirm gửi yêu cầu
        if (confirmUpdate || (timesCheckData >= 100 && checkDataOld.allowSubmit > 0)) {
          confirmUpdateUser(body, type);
        } else {
          setLoading(false)
          Swal.fire({
            icon: (checkDataOld.countMatch / checkDataOld.count < 0.5) ? "error" : "warning",
            title: "Chú ý",
            text: (checkDataOld.allowSubmit === 0 && type !== 'files') ? "Sai số điện thoại và email liên kết" : "Thông tin cũ bạn nhập đúng " + Math.round(checkDataOld.countMatch / checkDataOld.count * 100) + "%",
            showCancelButton: true,
            cancelButtonText: 'Quay về chỉnh sửa',
            confirmButtonText: 'Tiếp tục gửi',
            // chỉ khi có ít nhất 1 thông tin (số điện thoại hoặc email) đúng hoặc phương thức xác thực hình ảnh thì mới hiển thị nút confirm gửi yêu cầu
            showConfirmButton: (type === 'files' || checkDataOld.allowSubmit > 0),
            reverseButtons: true
          }).then((result) => {
            if (result.isConfirmed) {
              confirmUpdateUser(body, type);
            } else if (result.isDismissed) {
              setTimesCheckData(timesCheckData + 1)
            }
          });
        }
      }
    }
  };
  const closeModalConfirm = () => {
    setOpenConfirm(false);
    const nextRecentRequests = submittedRequest
      ? [
        { ...submittedRequest, request_code: maskRequestCode(submittedRequest.request_code) },
        ...(data?.recent_requests || []),
      ].slice(0, 2)
      : data?.recent_requests;
    navigate("/profile", { state: { userName, data: { ...data, recent_requests: nextRecentRequests }, webSetting } });
  };

  const handleMediaUpload = async (event) => {
    const files = Array.from(event.target.files);
    const validFiles = files.filter((file) => {
      if (file.size > 3 * 1024 * 1024) {
        Swal.fire({
          icon: "error",
          title: "Thất bại!",
          text: `File ${file.name} vượt quá giới hạn 3MB.`,
        });
        return false;
      }
      return true;
    });

    setSelectedFiles((prevFiles) => [...prevFiles, ...validFiles]);
    const newPreviews = validFiles.map((file) => ({
      url: URL.createObjectURL(file),
      type: file.type.startsWith("image") ? "image" : "video"
    }));
    if (previews.length + newPreviews.length > 7) {
      Swal.fire({
        icon: "error",
        title: "Thất bại!",
        text: "Hệ thống yêu cầu tối đa 7 file",
      });
      return;
    }
    const base64Images = await Promise.all(
      validFiles.map((file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
        });
      })
    );
    setPreviews((prevPreviews) => [...prevPreviews, ...newPreviews]);
    setSelectedImage((prevImages) => [...prevImages, ...base64Images]);
  };

  const handleRemoveImage = (index) => {
    setPreviews((prevPreviews) => prevPreviews.filter((_, i) => i !== index));
    setSelectedImage((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  return (
    <div className="container">
      {loading && <Loading loading={loading} />}
      <motion.div
        className="app"
        initial={{ x: "100vw", opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: "-100vw", opacity: 0 }}
        transition={{
          type: "spring",
          stiffness: 1000,
          damping: 200,
          duration: 10,
        }}
      >
        <Header
          isPageSearch={false}
          pageToAcction={"/profile"}
          data={{ userName, data, webSetting }}
          currentPage={typeModal}
          webSetting={webSetting}
        />

        <div className="content change-info-content-figma">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            id="modal-info"
            className="change-info-sheet-figma"
          >
            {/* Mục 1: Nhập lại thông tin đã liên kết theo flow gốc */}
            <div className="form-section-figma">
              <h3 className="section-title-dark">
                VUI LÒNG NHẬP LẠI THÔNG TIN ĐÃ LIÊN KẾT
              </h3>
              <div className="input-fields-figma">
                <div className="form-input-figma-row">
                  <input
                    type="text"
                    name="name"
                    value={dataCheck.name}
                    onChange={inputDataCheck}
                    placeholder="Họ Và Tên"
                    className="figma-input"
                  />
                  <img
                    src={iconInfoCircle}
                    alt="info"
                    className="input-info-icon"
                  />
                </div>
                {errors.name && <p className="error">{errors.name}</p>}

                <div className="form-input-figma-row">
                  <input
                    type="text"
                    name="phone_number"
                    value={dataCheck.phone_number}
                    onChange={inputDataCheck}
                    onBlur={() =>
                      setDataCheck((prev) => ({
                        ...prev,
                        phone_number: String(prev.phone_number || "").trim(),
                      }))
                    }
                    placeholder="Số Điện Thoại"
                    className="figma-input"
                  />
                  <img
                    src={iconInfoCircle}
                    alt="info"
                    className="input-info-icon"
                  />
                </div>
                {errors.phone_number && <p className="error">{errors.phone_number}</p>}

                <div className="form-input-figma-row">
                  <input
                    type="text"
                    name="email"
                    value={dataCheck.email}
                    onChange={inputDataCheck}
                    onBlur={() =>
                      setDataCheck((prev) => ({
                        ...prev,
                        email: String(prev.email || "").trim().toLowerCase(),
                      }))
                    }
                    placeholder="Email"
                    className="figma-input"
                  />
                  <img
                    src={iconInfoCircle}
                    alt="info"
                    className="input-info-icon"
                  />
                </div>
                {errors.email && <p className="error">{errors.email}</p>}

                <div className="form-input-figma-row select-row">
                  <select
                    name="bank_name"
                    value={dataCheck.bank_name}
                    onChange={inputDataCheck}
                    className="figma-select select-with-arrow"
                  >
                    <option value="">Chọn Ngân Hàng</option>
                    {config.LIST_BANK_NAME.map((bank, index) => (
                      <option key={index} value={bank}>
                        {bank}
                      </option>
                    ))}
                  </select>
                  <svg
                    className="select-polygon-arrow"
                    width="14"
                    height="10"
                    viewBox="0 0 19 14"
                    fill="none"
                  >
                    <polygon points="0,0 19,0 9.5,14" fill="#000000" />
                  </svg>
                </div>
                {errors.bank_name && (
                  <p className="error">{errors.bank_name}</p>
                )}

                <div className="form-input-figma-row">
                  <input
                    type="text"
                    name="bank_number"
                    value={dataCheck.bank_number}
                    onChange={inputDataCheck}
                    placeholder="Số Tài Khoản"
                    className="figma-input"
                  />
                  <img
                    src={iconInfoCircle}
                    alt="info"
                    className="input-info-icon"
                  />
                </div>
                {errors.bank_number && (
                  <p className="error">{errors.bank_number}</p>
                )}
              </div>
            </div>

            {/* Mục 2: Thay đổi thông tin mới */}
            <div className="form-section-figma">
              <h3 className="section-title-cyan">
                {typeModal === "forget_password" || typeModal === "forget_password_withdraw"
                  ? "THAY ĐỔI MẬT KHẨU"
                  : "THAY ĐỔI THÔNG TIN MỚI"}
              </h3>
              <div className="input-fields-figma">
                {
                  {
                    full_name: (
                      <>
                        <div className="form-input-figma-row">
                          <input
                            type="text"
                            name="name"
                            value={dataUpdate.name || ""}
                            onChange={inputDataUpdate}
                            onBlur={() =>
                              setDataUpdate((prev) => ({
                                ...prev,
                                name: normalizePersonName(prev.name),
                              }))
                            }
                            placeholder="Họ Và Tên Mới"
                            autoCapitalize="characters"
                            autoCorrect="off"
                            spellCheck={false}
                            className="figma-input"
                          />
                          <img
                            src={iconInfoCircle}
                            alt="info"
                            className="input-info-icon"
                          />
                        </div>
                        {errors.nameUpdate && (
                          <p className="error">{errors.nameUpdate}</p>
                        )}
                      </>
                    ),
                    phone_number: (
                      <>
                        <div className="form-input-figma-row">
                          <input
                            type="text"
                            name="phone_number"
                            value={dataUpdate.phone_number || ""}
                            onChange={inputDataUpdate}
                            placeholder="Số Điện Thoại Mới"
                            className="figma-input"
                          />
                          <img
                            src={iconInfoCircle}
                            alt="info"
                            className="input-info-icon"
                          />
                        </div>
                        {errors.phoneNumberUpdate && (
                          <p className="error">{errors.phoneNumberUpdate}</p>
                        )}
                      </>
                    ),
                    email: (
                      <>
                        <div className="form-input-figma-row">
                          <input
                            type="text"
                            name="email"
                            value={dataUpdate.email || ""}
                            onChange={inputDataUpdate}
                            placeholder="Email Mới"
                            className="figma-input"
                          />
                          <img
                            src={iconInfoCircle}
                            alt="info"
                            className="input-info-icon"
                          />
                        </div>
                        {errors.emailUpdate && (
                          <p className="error">{errors.emailUpdate}</p>
                        )}
                      </>
                    ),
                    bank: (
                      <>
                        <div className="form-input-figma-row select-row">
                          <select
                            name="bank_type_change"
                            value={dataUpdate.bank_type_change || ""}
                            onChange={inputDataUpdate}
                            className="figma-select select-with-arrow"
                          >
                            <option value="">Chọn yêu cầu thay đổi</option>
                            {config.LIST_REQUEST_BANK.map((req, index) => (
                              <option key={index} value={req}>
                                {req}
                              </option>
                            ))}
                          </select>
                          <svg
                            className="select-polygon-arrow"
                            width="14"
                            height="10"
                            viewBox="0 0 19 14"
                            fill="none"
                          >
                            <polygon points="0,0 19,0 9.5,14" fill="#000000" />
                          </svg>
                        </div>
                        {errors.bankTypeChange && (
                          <p className="error">{errors.bankTypeChange}</p>
                        )}

                        <div className="form-input-figma-row select-row">
                          <select
                            name="bank_name"
                            value={dataUpdate.bank_name || ""}
                            onChange={inputDataUpdate}
                            className="figma-select select-with-arrow"
                          >
                            <option value="">{desChangeBank.blockchain ?? "Chọn Ngân Hàng"}</option>
                            {desChangeBank.blockchain
                              ? [].map((bank, index) => (
                                <option key={index} value={bank}>
                                  {bank}
                                </option>
                              ))
                              : config.LIST_BANK_NAME.map((bank, index) => (
                                <option key={index} value={bank}>
                                  {bank}
                                </option>
                              ))}
                          </select>
                          <svg
                            className="select-polygon-arrow"
                            width="14"
                            height="10"
                            viewBox="0 0 19 14"
                            fill="none"
                          >
                            <polygon points="0,0 19,0 9.5,14" fill="#000000" />
                          </svg>
                        </div>
                        {errors.bankNameUpdate && (
                          <p className="error">{errors.bankNameUpdate}</p>
                        )}

                        <div className="form-input-figma-row">
                          <input
                            type="text"
                            name="bank_number"
                            value={dataUpdate.bank_number || ""}
                            onChange={inputDataUpdate}
                            placeholder={desChangeBank.bank_number || "Số tài khoản mới"}
                            className="figma-input"
                          />
                          <img
                            src={iconInfoCircle}
                            alt="info"
                            className="input-info-icon"
                          />
                        </div>
                        {errors.bankNumberUpdate && (
                          <p className="error">{errors.bankNumberUpdate}</p>
                        )}
                      </>
                    ),
                    birthday: (
                      <div className="form-input-figma-row">
                        <input
                          type="date"
                          name="birth_day"
                          onChange={inputDataUpdate}
                          placeholder="ngày tháng năm sinh"
                          defaultValue="2000-12-01"
                          className="figma-input"
                        />
                        {errors.birthDayUpdate && (
                          <p className="error">{errors.birthDayUpdate}</p>
                        )}
                      </div>
                    ),
                    forget_password: (
                      <div style={{ textAlign: "center", padding: "10px 0" }}>
                        <span className="section-title-cyan" style={{ display: "block", marginBottom: 8 }}>LẤY MẬT KHẨU ĐĂNG NHẬP</span>
                        <p className="note-verify-image" style={{ color: "#666", fontSize: 14 }}>Yêu cầu cấp lại mật khẩu đăng nhập. Vui lòng xác thực thông tin đã liên kết bên dưới.</p>
                      </div>
                    ),
                    forget_password_withdraw: (
                      <div style={{ textAlign: "center", padding: "10px 0" }}>
                        <span className="section-title-cyan" style={{ display: "block", marginBottom: 8 }}>LẤY MẬT KHẨU RÚT TIỀN</span>
                        <p className="note-verify-image" style={{ color: "#666", fontSize: 14 }}>Yêu cầu cấp lại mật khẩu rút tiền. Vui lòng xác thực thông tin đã liên kết bên dưới.</p>
                      </div>
                    ),
                  }[typeModal]
                }
              </div>
            </div>

            {/* Mục 3: Lựa chọn hình thức gửi xác thực theo Figma Frame 4 */}
            <div className="form-section-figma">
              <h3 className="section-title-dark">
                VUI LÒNG LỰA CHỌN HÌNH THỨC GỬI XÁC THỰC
              </h3>

              {typeModal !== "birthday" && (
                <>
                  <div className="verify-methods-row">
                    <button
                      type="button"
                      className="btn-verify-pill"
                      onClick={() => modalConfirmUpdate("mail")}
                    >
                      <img src={webSetting?.icon_email || badgeEmail} alt="Email" className="verify-badge-icon" />
                      <span className="verify-badge-text">GỬI QUA EMAIL</span>
                    </button>

                    <button
                      type="button"
                      className="btn-verify-pill"
                      onClick={() => modalConfirmUpdate("phone_number")}
                    >
                      <img src={webSetting?.icon_phone || badgePhone} alt="SĐT" className="verify-badge-icon" />
                      <span className="verify-badge-text">GỬI QUA SĐT</span>
                    </button>
                  </div>
                  <p className="note-verify-image" style={{ textAlign: "center", color: "#666", fontSize: 13, margin: "10px 0" }}>
                    Nếu quý khách không có email hoặc SĐT để gửi thông tin, vui lòng nhấn nút dưới đây để thực hiện thay thế
                  </p>
                </>
              )}

              <label className="upload-media-box-figma" htmlFor="media-upload-input">
                <input
                  id="media-upload-input"
                  type="file"
                  multiple
                  accept="image/*,video/*"
                  style={{ display: "none" }}
                  onChange={handleMediaUpload}
                />
                <img src={iconUploadImage} alt="upload" />
                <span>Tải ảnh hoặc video để xác thực</span>
              </label>

              {previews.length > 0 ? (
                <div className="previews-list-figma">
                  {previews.map((preview, index) => (
                    <div
                      key={index}
                      className="preview-thumb-figma"
                      onClick={() => handleRemoveImage(index)}
                    >
                      <img src={preview.url} alt="upload" />
                      <span className="preview-remove-btn">×</span>
                    </div>
                  ))}
                  <button
                    type="button"
                    id="confirm_files_btn"
                    className="btn-submit-files-pill"
                    onClick={() => modalConfirmUpdate("files")}
                  >
                    GỬI ẢNH/VIDEO XÁC THỰC
                  </button>
                </div>
              ) : (
                <div className="action action-verify" style={{ marginTop: 12 }}>
                  <button
                    type="button"
                    id="confirm_files_btn"
                    className="btn-submit-files-pill"
                    onClick={() => modalConfirmUpdate("files")}
                  >
                    TẢI LÊN HÌNH ẢNH VIDEO THAY THẾ XÁC THỰC
                  </button>
                </div>
              )}
            </div>
          </motion.div>

          {/* Modal xác nhận yêu cầu (Figma Frame 15, 16) */}
          <Popup
            open={openConfirm}
            closeOnDocumentClick={false}
            onClose={closeModalConfirm}
            position={"center"}
            nested
            overlayStyle={{
              background: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            contentStyle={{
              background: "transparent",
              border: "none",
              padding: 0,
              width: "auto",
            }}
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.3 }}
              className="modal-figma-container"
            >
              <div id="modal-confirm" className="modal-figma-card">
                {user.send_type === "files" ? (
                  <div className="modal-figma-body">
                    <img
                      className="modal-header-icon"
                      src={modalSuccess}
                      alt="Success"
                    />
                    <p className="modal-message-text">
                      Chúng tôi đã nhận được yêu cầu của Quý khách, vui lòng chờ
                      2-5 phút và nhận kết quả phản hồi tại Hòm thư nội bộ
                    </p>
                    <RequestProcessingStatus
                      submittedRequest={submittedRequest}
                      pollingChecks={pollingChecks}
                      isRefreshingRequest={isRefreshingRequest}
                      requestRefreshMessage={requestRefreshMessage}
                      refreshSubmittedRequest={refreshSubmittedRequest}
                      copySubmittedRequestCode={copySubmittedRequestCode}
                    />
                    <div className="btn-wrapper-home">
                      <div className="btn-send btn-home">
                        <a
                          href={webSetting.link_home}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          VỀ TRANG CHỦ
                        </a>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="modal-figma-body">
                    <img
                      className="modal-header-icon"
                      src={modalExclamation}
                      alt="Lưu ý"
                    />
                    {isSendMail ? (
                      <p className="modal-instruction-text">
                        Vui lòng sử dụng gmail đã liên kết{" "}
                        <span className="text-red-highlight">
                          {data?.email}
                        </span>
                        , gửi tin nhắn tới email{" "}
                        <span className="text-blue-highlight">
                          {webSetting.email}
                        </span>
                        , với nội dung:
                      </p>
                    ) : user.send_type === "phone_number" ? (
                      <p className="modal-instruction-text">
                        Vui lòng sử dụng số điện thoại đã liên kết{" "}
                        <span className="text-green-highlight">
                          {data?.phone_number}
                        </span>
                        , gửi tin nhắn tới số điện thoại SHBET{" "}
                        <span className="text-red-highlight">
                          {webSetting.phone_number}
                        </span>
                        , với nội dung:
                      </p>
                    ) : (
                      <p className="modal-message-text">
                        Yêu cầu của quý khách đã được ghi nhận. Vui lòng đợi xét duyệt.
                      </p>
                    )}

                    <DataConfirm
                      user={user}
                      dataCheck={dataCheck}
                      dataUpdate={dataUpdate}
                      webSetting={webSetting}
                    />

                    <p className="modal-italic-note">
                      Vui lòng nhấn Xác nhận sau khi đã gửi thành công
                    </p>

                    <button
                      type="button"
                      className="btn-confirm-sent-figma"
                      onClick={closeModalConfirm}
                    >
                      XÁC NHẬN ĐÃ GỬI
                    </button>

                    <RequestProcessingStatus
                      submittedRequest={submittedRequest}
                      pollingChecks={pollingChecks}
                      isRefreshingRequest={isRefreshingRequest}
                      requestRefreshMessage={requestRefreshMessage}
                      refreshSubmittedRequest={refreshSubmittedRequest}
                      copySubmittedRequestCode={copySubmittedRequestCode}
                    />
                  </div>
                )}
              </div>
              <button
                type="button"
                className="modal-close-icon-btn-bottom"
                onClick={closeModalConfirm}
                aria-label="Đóng"
              >
                <img src={modalClose} alt="Đóng" />
              </button>
            </motion.div>
          </Popup>

          {/* Modal kết quả thành công (Figma Frame 14) */}
          <Popup
            open={openResult}
            onClose={() => setOpenResult(false)}
            position={"center"}
            overlayStyle={{
              background: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            contentStyle={{
              background: "transparent",
              border: "none",
              padding: 0,
              width: "auto",
            }}
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.3 }}
              className="modal-figma-container"
            >
              <div className="modal-figma-card">
                {checkConfirm ? (
                  <div className="modal-figma-body">
                    <img
                      className="modal-header-icon"
                      src={modalSuccess}
                      alt="Success"
                    />
                    <p className="modal-message-text">
                      Chúng tôi đã nhận được yêu cầu của Quý khách, vui lòng chờ
                      2-5 phút và nhận kết quả phản hồi tại Hòm thư nội bộ
                    </p>
                  </div>
                ) : (
                  <div className="modal-figma-body">
                    <img
                      className="modal-header-icon"
                      src={modalExclamation}
                      alt="Warning"
                    />
                    <p className="modal-message-text">
                      Yêu cầu của bạn chưa được ghi nhận, vui lòng thử lại hoặc
                      liên hệ chăm sóc khách hàng
                    </p>
                  </div>
                )}
              </div>
              <button
                type="button"
                className="modal-close-icon-btn-bottom"
                onClick={() => setOpenResult(false)}
                aria-label="Đóng"
              >
                <img src={modalClose} alt="Đóng" />
              </button>
            </motion.div>
          </Popup>
          <Popup
            open={openUploadFile}
            onClose={() => setOpenUploadFile(false)}
            position={"center"}
            overlayStyle={{
              background: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            contentStyle={{
              background: "transparent",
              border: "none",
              padding: 0,
              width: "auto",
            }}
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.3 }}
              className="modal-figma-container"
            >
              <div className="modal-figma-card">
                <div className="modal-figma-body">
                  <img
                    className="modal-header-icon"
                    src={modalExclamation}
                    alt="Warning"
                  />
                  <p className="modal-message-text">
                    Bạn cần cung cấp thêm hình ảnh/video để xác minh thông tin.
                  </p>

                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{
                      color: "black",
                      marginBottom: "-10px",
                      marginTop: "-15px",
                      fontWeight: "bold",
                    }}
                  >
                    <div className='upload-file' dangerouslySetInnerHTML={{ __html: infoFileUpload }} />
                  </Typography>
                  <Box
                    display="flex"
                    alignItems="center"
                    marginY={1}
                    flexWrap="wrap"
                    gap="8px 8px"
                  >
                    {previews.map((preview, index) => (

                      <Box
                        onClick={() => handleRemoveImage(index)}
                        key={index}
                        sx={{
                          maxHeight: 80,
                          maxWidth: 90,
                          width: "auto",
                          height: "auto",
                          position: "relative",
                          overflow: "hidden",
                          cursor: "pointer",
                          "&:hover .delete-button": {
                            display: "block",
                          },
                        }}
                      >
                        {console.log("preview", preview)}
                        {preview.type === "image" ? (
                          <img
                            src={preview.url}
                            alt={`preview-${index}`}
                            style={{
                              width: "auto",
                              maxWidth: "100%",
                              height: "auto",
                              maxHeight: "100%",
                              borderRadius: 4,
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <video
                            src={preview.url}
                            controls
                            style={{
                              width: "auto",
                              maxWidth: "100%",
                              height: "auto",
                              maxHeight: "100%",
                              borderRadius: 4,
                              objectFit: "cover",
                            }}
                          />
                        )}
                        <IconButton
                          className="delete-button"
                          sx={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                            color: "red",
                            p: 0,
                          }}
                        >
                          <Close fontSize="small" />
                        </IconButton>
                      </Box>
                    ))}

                    <Box>
                      <input
                        accept="image/*, video/*"
                        style={{ display: "none" }}
                        id="upload-button"
                        type="file"
                        onChange={handleMediaUpload}
                        multiple
                      />
                      <label htmlFor="upload-button">
                        <Button
                          variant="outlined"
                          component="span"
                          startIcon={
                            <AddPhotoAlternateOutlined
                              sx={{ fontSize: "large" }}
                            />
                          }
                          sx={{
                            width: "90px",
                            height: "80px",
                            color: "#6BB0C8",
                            borderColor: "#6BB0C8",
                            borderStyle: "solid",
                            "&:hover": {
                              borderColor: "#6BB0C8",
                              color: "#6BB0C8",
                            },
                          }}
                        >
                          Thêm
                        </Button>
                      </label>
                    </Box>
                  </Box>
                  <Typography variant="caption" sx={{ color: "#B0B3C1" }}>
                    Cung cấp hình ảnh/video đúng theo mô tả để được xét duyệt <br /> (Hình ảnh/video không được vượt quá 3MB)
                  </Typography>
                  {selectedImage.length >= 3 && (
                    <div>
                      <button id="complete_files_btn" onClick={() => { setOpenUploadFile(false); updateUser(user.send_type, true) }}>
                        Hoàn thành xác minh
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <button
                type="button"
                className="modal-close-icon-btn-bottom"
                onClick={() => setOpenUploadFile(false)}
                aria-label="Đóng"
              >
                <img src={modalClose} alt="Đóng" />
              </button>
            </motion.div>
          </Popup>
        </div>
      </motion.div>
    </div>
  );
}

export default ChangeInfo;
